<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M19.02 3.51H4.98A4.98 4.98 0 0 0 0 8.49v7.01a4.98 4.98 0 0 0 4.98 4.98h14.03a4.98 4.98 0 0 0 4.98-4.98V8.49a4.966 4.966 0 0 0-4.97-4.98zm-3.38 8.83-6.56 3.13a.267.267 0 0 1-.38-.24V8.78c0-.2.21-.32.38-.24l6.56 3.33c.21.1.2.38 0 .47z"
    />
  </svg>
</template>
